const TazaIcon = () => {
  return (
    <svg
      width="70"
      height="65"
      viewBox="0 0 70 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="50.9609"
        y="27.2188"
        width="17"
        height="16"
        rx="7"
        stroke="#002133"
        strokeWidth="4"
      />
      <path
        d="M11.9634 22.2188H47.9609C52.9315 22.2188 56.9609 26.2482 56.9609 31.2187V39.4365C56.9609 39.6108 56.9557 39.7197 56.9454 39.8044C56.8506 40.581 56.3319 43.8094 53.7999 49.556C50.1807 57.7701 40.2575 62.2188 29.7663 62.2188C19.2751 62.2188 9.35194 57.7701 5.73276 49.556C3.22387 43.8618 2.98382 40.6972 2.96283 39.9891C2.95982 39.8872 2.96062 39.8103 2.96174 39.7035C2.96248 39.6328 2.96336 39.549 2.96336 39.4363V31.2187C2.96336 26.2482 6.99279 22.2188 11.9634 22.2188Z"
        fill="white"
        stroke="#002133"
        strokeWidth="4"
      />
      <path
        d="M12.2646 43.3137C13.7639 48.779 16.5484 51.6657 21.652 54.0104"
        stroke="#002133"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M16.125 9.42188C20.5483 11.7189 20.8356 15.6551 15.4717 17.6247"
        stroke="#002133"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M17.8281 10.6016C13.3616 8.36971 12.999 4.43826 18.3245 2.39031"
        stroke="#002133"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M28.3516 9.42188C32.7748 11.7189 33.0622 15.6551 27.6983 17.6247"
        stroke="#002133"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M30.0547 10.6016C25.5881 8.36971 25.2256 4.43826 30.5511 2.39031"
        stroke="#002133"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M41.8438 9.42188C46.267 11.7189 46.5544 15.6551 41.1905 17.6247"
        stroke="#002133"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M43.5391 10.6016C39.0725 8.36971 38.7099 4.43826 44.0354 2.39031"
        stroke="#002133"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default TazaIcon;
